import { INITIALIZE_SMART_DOCUMENT_FORM } from '../actionTypes';
import { templateDocumentsActions } from '../reducer';

export default (values) =>
    templateDocumentsActions[INITIALIZE_SMART_DOCUMENT_FORM](values);
